import React from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as fundsActions from '../../../redux/actions/FundsActions';

import FundModal from '../fundsCommon/FundModal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import Toggle from '../../commonComponents/util/Toggle';

import { formatCurrency, formatDate } from '../../../lib/utils';
import { Departments, PermissionTypes } from '../../../lib/systemVariables';
import { toastr } from 'react-redux-toastr';


class FundsPage extends NavigationComponent {

    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                fundModal: false
            },
            showInactiveFunds: false
        };
    }

    componentWillMount() {
        this.getFunds();
    }

    async getFunds() {
        await this.props.actions.getFundsVerbose();
        if (!this.props.funds.success) toastr.error('Something went wrong', `We were unable to retrieve funds.  Please try again.`);
    }

    onToggleChange = (name, value) => {
        this.setState({ [name]: value });
    }

    render() {
        const allFunds = this.props.funds.data || [];
        const filteredFunds = this.state.showInactiveFunds ? allFunds : allFunds.filter(fund => fund.active !== false);

        return (
            <div className="page">
                <div className="subheader funds-subheader">
                    <div className="container flex-justify">
                        <h2 className="page-header">SFTF Funds</h2>
                        <div className="action-buttons">
                            <div className="funds-filter-toggle flex-center">
                                <Toggle
                                    id="inactive-funds"
                                    name="showInactiveFunds"
                                    value={this.state.showInactiveFunds}
                                    onChange={this.onToggleChange}
                                />
                                <span className="small-text">Show Inactive</span>
                            </div>
                            {this.props.userPermissions.manageAccounting && <button className="btn btn-primary btn-small" onClick={this.toggleModal.bind(null, 'fundModal')}>Add Fund</button>}
                        </div>
                    </div>
                </div>

                <div className="container funds-page">
                    {this.props.funds.loading ? <LoadingSpinner height={40} />
                        : filteredFunds.length ? filteredFunds.map(fund =>
                            <Link
                                key={fund.fundId}
                                to={`/accounting/${fund.fundId}`}
                            >
                                <div className="card fund">
                                    <div className="fund-card-content flex-justify">
                                        <div className="fund-card-left">
                                            <div className="fund-name">
                                                <h4>{fund.name}</h4>
                                                <span className={`fund-status ${fund.active ? 'fund-status-active' : 'fund-status-inactive'}`}>
                                                    <span className="fund-status-dot"></span>
                                                    {fund.active ? 'Active' : 'Inactive'}
                                                </span>
                                            </div>
                                            <p className="medium-text"><i
                                                className="icon-home icon-left accent-text2 middle"></i>{fund.bankName}</p>
                                            <p className="medium-text"><i
                                                className="icon-user icon-left accent-text2 middle"></i>Account
                                            #{fund.accountNumber}</p>
                                            <p className="medium-text accent-text"><i
                                                className="icon-clock icon-left middle"></i>Last Activity
                                            on {formatDate(fund.lastUpdated)} by {fund.lastUpdatedBy}</p>
                                        </div>
                                        <div className="fund-card-right flex-center">
                                            <div className="flex-center">
                                                <div>
                                                    <i className="icon-notebook icon-left gradient-icon"></i>
                                                </div>
                                                <div>
                                                    <p className="xs-text accent-text uppercase-text">Book Balance</p>
                                                    <p className="xl-text">{formatCurrency(fund.bookBalance, fund.department === Departments.IL)}</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="flex-center">
                                                <div>
                                                    <i className="icon-check icon-left gradient-icon"></i>
                                                </div>
                                                <div>
                                                    <p className="xs-text accent-text uppercase-text">Approved
                                                    Applications</p>
                                                    <p className="xl-text accent-text3">{formatCurrency(fund.totalApproved, fund.department === Departments.IL)}</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="flex-center">
                                                <div>
                                                    <i className="icon-wallet icon-left gradient-icon"></i>
                                                </div>
                                                <div>
                                                    <p className="xs-text accent-text uppercase-text">Available Balance</p>
                                                    <p className={`xl-text ${fund.availableBalance < 0 ? 'error-text' : 'approved-text'}`}>{formatCurrency(fund.availableBalance, fund.department === Departments.IL)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ) : <p className="empty-state"><i className="material-icons">not_interested</i>No Funds Available</p>
                    }
                </div>
                <FundModal show={this.state.showModals.fundModal} close={this.toggleModal.bind(null, 'fundModal')}
                    utils={this.props.utils}
                    loading={this.props.newFund.loading} success={this.props.newFund.success}
                    userPermissions = {this.props.userPermissions}
                    createFund={this.props.actions.createFund} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.funds,
        utils: {
            banks: state.settings.systemSettings.data.fundSettings.banks,
            departments: state.settings.systemSettings.data.otherSettings.departments,
            unitTypes: state.settings.systemSettings.data.otherSettings.unitTypes
        },
        userPermissions: {
            manageAccounting: state.userProfile.permissions.data.indexOf(PermissionTypes.AccountingManage) >= 0,
            admin: state.userProfile.profile.data.roleId === 1        }
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(fundsActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FundsPage);



// WEBPACK FOOTER //
// ./src/components/accountingComponents/funds/FundsPage.jsx